import React from 'react';

import ProductSection from '@gik/product-page/components/ProductSection/ProductSection';
import { InkindPageViewHistoryItem, getInkindPageViewHistory } from '@gik/inkind-page';

interface ProductPageContainerProps {
  productId: number;
  inkindRouteId?: string;
  className?: string;
}

export default function ProductPageContainer({
  productId,
  inkindRouteId,
  className,
}: ProductPageContainerProps): JSX.Element {
  const inkindPageViewHistory: InkindPageViewHistoryItem[] = getInkindPageViewHistory();

  return (
    <div className={`product-page-container ${className}`}>
      <ProductSection
        productId={productId}
        inkindRouteId={inkindRouteId}
        inkindPageViewHistory={inkindPageViewHistory}
        type={inkindRouteId ? 'wishlist' : 'productPage'}
      />
    </div>
  );
}
